module.exports = __webpack_public_path__ + "static/media/corrector.e63fb95f.jpg";